<template>
  <b-card no-body>
    <b-card-body>
      <purchase-offer-search-bar :call-back="searchData" />
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(title)="data">
        <div v-if="data.item.onumber">
          <small class="text-primary">{{ data.item.onumber }}</small>
        </div>
        {{ data.item.title }}
      </template>
      <template #cell(username)="data">
        {{ data.item.username }}
        <div>
          <small
            v-if="data.item.created"
            class="text-secondary"
          >
            <feather-icon icon="SaveIcon" />
            {{ moment(data.item.created).format('DD.MM.YYYY') }}
          </small>
          <div v-if="data.item.modified">
            <small
              v-if="data.item.modified"
              class="text-warning"
            >
              <feather-icon icon="EditIcon" />
              {{ moment(data.item.modified).format('DD.MM.YYYY') }}
            </small>
          </div>
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <b-dropdown
            v-if="(userData.id === data.item.id_users && data.item.id_confirmed_user === null && !['6','7','8'].includes(data.item.id_purchase_offer_status))|| userData.id_user_types === '1'"
            variant="primary"
            text="Görüntüle"
            left
            split
            size="sm"
            @click="showPage('/app/purchase-offers/view/' + data.item.id)"
          >
            <b-dropdown-item
              v-if="userData.id === data.item.id_users && data.item.id_confirmed_user === null && !['6','7','8'].includes(data.item.id_purchase_offer_status)"
              :to="'/app/purchase-offers/edit/' + data.item.id"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">Düzenle</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="(userData.id === data.item.id_users && data.item.id_confirmed_user === null && !['6','7','8'].includes(data.item.id_purchase_offer_status)) || userData.id_user_types === '1'"
              @click="removeData(data.item.id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Sil</span>
            </b-dropdown-item>
          </b-dropdown>
          <b-button
            v-else
            variant="primary"
            size="sm"
            @click="showPage('/app/purchase-offers/view/' + data.item.id)"
          >
            <feather-icon icon="EyeIcon" />
            <span class="align-middle ml-50">Görüntüle</span>
          </b-button>
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BDropdown, BDropdownItem, BRow, BCol,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PurchaseOfferSearchBar from '@/views/Admin/Purchase_offers/Components/SearchBar.vue'

const tableName = 'purchase_offers'
export default {
  name: 'Index',
  components: {
    PurchaseOfferSearchBar,
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'Başlık',
        },
        {
          key: 'status',
          label: 'Son Durum',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'username',
          label: 'Düzenleyen',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.onumber AS onumber`,
          `${tableName}.title AS title`,
          `${tableName}.created AS created`,
          `${tableName}.modified AS modified`,
          `${tableName}.id_purchase_offer_status AS id_purchase_offer_status`,
          `${tableName}.id_confirmed_user AS id_confirmed_user`,
          `${tableName}.id_users AS id_users`,
          'users.name AS username',
          'purchase_offer_status.title AS status',
        ],
        where: {},
        or_like: {},
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['purchaseOffers/dataList']
    },
    dataCounts() {
      return this.$store.getters['purchaseOffers/dataCounts']
    },
    saveData() {
      return this.$store.getters['purchaseOffers/dataSaveStatus']
    },
    search() {
      return this.$store.getters['purchaseOffers/search']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      if (this.search.keyword) {
        this.dataQuery.or_like = {
          'purchase_offers.title': this.search.keyword,
          'purchase_offers.onumber': this.search.keyword,
          'confirmed_suppliers.company': this.search.keyword,
          'confirmed_suppliers.phone': this.search.keyword,
          'confirmed_suppliers.email': this.search.keyword,
        }
      } else {
        this.dataQuery.or_like = {}
      }
      if (this.search.id_users) {
        this.dataQuery.where['purchase_offers.id_users'] = this.search.id_users
      } else if (this.dataQuery.where['purchase_offers.id_users']) {
        delete this.dataQuery.where['purchase_offers.id_users']
      }
      if (this.search.id_purchase_offer_status) {
        this.dataQuery.where['purchase_offers.id_purchase_offer_status'] = this.search.id_purchase_offer_status
      } else if (this.dataQuery.where['purchase_offers.id_purchase_offer_status']) {
        delete this.dataQuery.where['purchase_offers.id_purchase_offer_status']
      }
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('purchaseOffers/getDataList', this.dataQuery)
    },
    showPage(url) {
      // window.open(url)
      this.$router.push(url)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('purchaseOffers/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
